const formatter = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Formats a decimal fraction as a percentage string.
 *
 * `Intl.NumberFormat` with `style: 'percent'` multiplies the value by 100 internally,
 * so the input must be a fraction in the range 0–1, not 0–100.
 *
 * @example
 * formatPercent(1)      // → "100.00%"
 * formatPercent(0.5)    // → "50.00%"
 * formatPercent(0.1234) // → "12.34%"
 */
export const formatPercent = (value: number): string => formatter.format(value);
